export const ACTION_TYPES = {
	SET_WEATHER: 'SET_WEATHER',
	REMOVE_WEATHER: 'REMOVE_WEATHER',
}